var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.12376 10.1457L12.6834 3.55233C12.8521 3.23999 12.8893 2.88065 12.7878 2.54101C12.6862 2.20089 12.458 1.9203 12.1458 1.75209L11.3665 1.33123C10.7223 0.983284 9.91414 1.22411 9.56639 1.86886L6.08202 8.32065L9.12376 10.1457ZM8.68999 10.7427L5.74675 8.9768C5.74417 8.99321 5.74297 9.00984 5.74319 9.02653L5.77944 12.0662C5.78086 12.1738 5.84019 12.2714 5.93435 12.3227C6.00439 12.3605 6.08501 12.3682 6.15934 12.346C6.1851 12.3383 6.21032 12.327 6.23389 12.3121L8.68999 10.7427Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33301 4.34375H5.74382C5.94682 4.34375 6.11139 4.50832 6.11139 4.71132C6.11139 4.91432 5.94682 5.07889 5.74382 5.07889H2.06814V14.2681H12.36V9.12213C12.36 8.91913 12.5246 8.75456 12.7276 8.75456C12.9306 8.75456 13.0952 8.91913 13.0952 9.12213V15.0032H1.33301V4.34375Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencil);
export default __webpack_public_path__ + "static/media/edit-pencil.722320a0.svg";
export { ForwardRef as ReactComponent };